import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  // resources,
  lng: 'en',
  fallbackLng: 'en',
  // ns: ['astronautAlarms'],
  // defaultNS: 'astronautAlarms',
  // fallbackNS: 'astronautAlarms',
  interpolation: {
    escapeValue: false,
  },
  keySeparator: '.', // Enable nesting
  nsSeparator: ':', // Enable namespaces
});

// Function to update language when store is ready
export const updateI18nLanguage = (language: string) => {
  i18n.changeLanguage(language);
};

export default i18n;
